export default "__VITE_ASSET__DRRMAmtL__"